import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  private locale: string = localStorage.getItem('locale') ?? 'en';
  
  public localeSubject: BehaviorSubject<string> = new BehaviorSubject(this.locale)

  constructor() {}

  ngOnInit() {}

  set langSetter(lang: string) {
    localStorage.setItem('locale', lang);
    this.localeSubject.next(lang);
  }

  get currentLang() {
    return this.locale
  }
}
